import{jsx as t,Fragment as e}from"react/jsx-runtime";import n from"styled-components";import{calculateRem as o}from"@vds-core/utilities";import{LayoutTokens as r}from"@vds-tokens/layout";import"../Controls/PaginationStepControl.js";import i from"../Controls/PaginationListItem.js";import a from"../Controls/PaginationLink.js";const s=n(i).withConfig({displayName:"PaginationNumbersContainer",componentId:"VDS__sc-75hqso-0"})`
  display: flex;
  height: ${o("16px")};
  justify-content: center;
  min-width: ${o("20px")};

  ${function({index:t,$startRange:e}){return t!==e&&`margin-left: ${o(r.space["1X"].value)};`}}
`,l=n.span.withConfig({displayName:"StyledSpan",componentId:"VDS__sc-75hqso-1"})`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  svg {
    margin-top: -1px;
  }
`,c=function(n){const{total:o,selectedPage:r,baseUrl:i,selectPage:c,surface:m}=n,{startRange:p,endRange:f}=function(t,e){const n=t<98?3:2;let o=Math.min(t-1,e-n);return 1===t&&(o=1),{startRange:o,endRange:o+n}}(r,o),g=function(t){null==c||c(t)};return t(e,{children:Array.from({length:o+1},(function(t,e){return e})).map((function(e,n){return n>=p&&n<=f&&0!==n&&t(s,{$startRange:p,index:n,children:t(a,{pageNumber:n,selectedPage:r,baseUrl:i,onClick:g,surface:m,total:o,children:t(l,{children:n})})},n)}))})};c.defaultProps={total:20,selectedPage:10,surface:"light"};export{c as default};
